export enum Direction {
  IN = "In",
  OUT = "Out"
}
